<template>
	<div class="report-before">
		<div class="report-before-cow"></div>
		<div class="report-before-main-content-top"></div>
		<div class="report-before-main-content">
			<div class="report-before-content-box" :style="'height:'+height+'px'">
				<div class="report-before-content">
					<div class="report-before-title">
						本程序以你出生时太阳、地球、月亮、木星、土星等主要星球位置信息进行数据建模再结合2023年地球运行轨迹，最终计算出你在新一年的卯力值。我们已计算出你的先天天赋和2022的状况来验证与生日信息是否匹配。
					</div>
					<!-- 主要信息 -->
					<div class="report-before-info">
						<div class="report-before-sub-title">
							<span class="title-line"></span><span class="text">先天天赋</span>
						</div>
						<div class="report-before-table">
							<report-radar-data-area
								:canvasId="'beforeCanvas'" 
								:indicatorArr="userBaseTalentIndicator"
								:valueArr="userBaseTalentValue">
							</report-radar-data-area>
						</div>
						<div class="report-before-i-text text1">{{userTips}}</div>
					</div>
					
					<!-- 2020年的状态回顾 -->
					<div class="report-before-info">
						<div class="report-before-sub-title">
							<span class="title-line"></span><span class="text">2022年的状态回顾</span>
						</div>
						<div class="report-before-i-text">{{userEvent[0]}}</div>
					</div>
				</div>
				<div class="report-before-more-box">
					<div class="report-before-more">
						<span class="title">科普小知识：</span>
						2023年2月4日太阳到达黄经315度，从此我们进入兔年的能量场。之后每移动15度将切换一个时空能量，正好对应12个月的时间。而在这期间随着地球自转、公转的发生，太阳、月亮及和五大行星对你的影响将决定了你的前兔运势走向，即卯力变化。
					</div>
				</div>
			</div>
			
			<div class="index-main-button-box report-before-button-box">
				<div class="index-main-button" @click="clickGoOn">查看前兔卯力值</div>
			</div>
		</div>
	</div>
</template>

<script>
	import ReportRadarDataArea from './ReportRadarDataArea.vue'
	export default {
		components: { ReportRadarDataArea },
		computed: {
			userEvent() {
				return this.$store.state.user.userEvent;	
			},
			userTips() {
				return this.$store.state.user.userTips;
			},
			userBaseTalentIndicator() {
				return this.$store.state.user.userBaseTalentIndicator;
			},
			userBaseTalentValue() {
				return this.$store.state.user.userBaseTalentValue;
			}
		},
		data() {
			return {
				height: 250,
				categories: ['维度1', '维度2', '维度3', '维度4', '维度5', '维度6'],
				series: [{
					name: '成交量1',
					data: [90, 110, 165, 195, 187, 172],
					color: '#E02020'
				}]
			}
		},
		mounted() {
			var me = this;
			setTimeout(() => {
				me.height = window.screen.height*0.4;
			}, 20);
		},
		methods: {
			clickGoOn() {
				this.$store.state.user.isNewCreated = false;
            	this.$store.state.user.reportShowBefore = false;
			}
		}
	}
</script>

<style>
</style>
